// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

export const ComponentSpacerFragmentDoc = `
    fragment componentSpacer on ComponentSpacer {
  __typename
  spacing
}
    `;